import { AutocompleteChangeReason } from "@mui/material"
import React, { useEffect } from "react"
import { DataGrid, Grid, IconButton, IGridColDef, Stack } from "src/components"
import { translate } from "src/i18n/tHelper"
import RecordInfo from "src/parts/Genel/record.info"
import { useAppDispatch, useAppSelector } from "src/store"
import SnackbarUtils from "src/utils/SnackbarUtils"
import { useConfirmation } from "src/base/ConfirmationDialog/ConfirmationService"
import ParametreGrupEnum from "src/enums/ParametreGrupEnum"
import VwSonucIzlemeTanimDTO from "src/models/Settings/Generals/VwSonucIzlemeTanimDTO"
import { SonucIzlemeTanimSlice } from "src/store/Slices/GenelTanimlar/SonucIzlemeTanimSlice"
import { useParametreDetayListesiQuery } from "src/services/gnlparametre/ParametreTanimApi"
import GnlParametreDTO from "src/models/GnlParametre/GnlparametreDTO"
import Paper from "src/components/Paper"
import { useSonucIzlemeTanimListesiQuery, useSonucIzlemeTanimSilMutation } from "src/services/geneltanimlar/SonucIzlemeTanimApi"
import { GridRenderCellParams } from '@mui/x-data-grid-premium';
import GnlParametreSelect from "src/parts/Genel/gnl.parametre.select"
import { AutoCompleteTargetNumber } from "src/parts/Types/autocomplete.target"

const translatePath = "pages|genelTanimlar|sonucIzlemeTanim"

const SonucIzlemeTanimListe = (): JSX.Element => {
    const state = useAppSelector(state => state.sonucIzlemeTanim);
    const dispatch = useAppDispatch();
    const confirm = useConfirmation();
    const grupId = state.testGrubu?.key === 7
        ? ParametreGrupEnum.LaboratuvarPatolojiNumuneDurumları
        : ParametreGrupEnum.IslemDurumu;

    const durumlar = useParametreDetayListesiQuery({
        grupId: grupId,
        iptal: "E"
    });

    const { data: sonucIzlemeData, isFetching: isSonucIzlemeFetching } = useSonucIzlemeTanimListesiQuery();
    const [sil] = useSonucIzlemeTanimSilMutation();

    useEffect(() => {
        dispatch(SonucIzlemeTanimSlice.actions.setTestGrubu({ key: 1 })); // Default Lab
    }, [])

    const durumColumns: IGridColDef<GnlParametreDTO>[] = [
        {
            field: 'kodu',
            headerName: translate(translatePath, "Kodu"),
            type: 'number',
            width: 70,
            align: 'center',
        },
        {
            field: 'adi',
            headerName: translate(translatePath, "Parametre Adı"),
            flex: 1,
            minWidth: 260
        },
        {
            field: 'sirano',
            headerName: translate(translatePath, 'Sıra No'),
            width: 120,
            editable: true
        },
        {
            field: 'aktif',
            headerName: translate(translatePath, "Aktif"),
            type: 'boolean',
            width: 75,
            valueGetter: (params) => {
                return params.row?.aktif === "E"
            }
        },
        {
            field: "action",
            headerName: "",
            disableColumnMenu: true,
            resizable: false,
            filterable: false,
            sortable: false,
            width: 80,
            renderCell: (params) => {
                return (
                    <Stack direction="row">
                        <IconButton
                            customType="add"
                            onClick={(e) => { addHandler(e, params); }}
                        />
                        <RecordInfo
                            id={params.row.id}
                            eklemeTarihi={params.row.eklemeTarihi}
                            ekleyenKullanici={params.row.ekleyenKullanici}
                            guncellemeTarihi={params.row.guncellemeTarihi}
                            guncelleyenKullanici={params.row.guncelleyenKullanici}
                        />
                    </Stack>
                )
            }
        }

    ];
    const sonucIzlemeTanimColumns: IGridColDef<VwSonucIzlemeTanimDTO>[] = [

        {
            field: "testGrupAdi",
            headerName: translate(translatePath, "Grup Adı"),
            width: 150,

        },
        {
            field: "durumId",
            headerName: translate(translatePath, "Durum"),
            width: 150,
            renderCell: (params) => {
                return durumlar.data?.find(d => d.kodu == params.row.durumId)?.adi;
            }

        },
        {
            field: "bgRenk",
            headerName: translate(translatePath, "Renk"),
            width: 150,
            renderCell: (params) => {
                const renkKodu = params.value;

                return (

                    <div style={{

                        backgroundColor: renkKodu,
                        color: params.row.txRenk,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        paddingLeft: '10px',
                    }}>
                        {translate(translatePath, "Metin Rengi")}
                    </div>
                );
            }
        },
        {
            field: 'aktif',
            headerName: translate(translatePath, "Aktif"),
            type: 'boolean',
            width: 75,
            valueGetter: (params) => {
                return params.row?.aktif === "E"
            }
        },
        {
            field: "action",
            headerName: "",
            width: 110,
            disableColumnMenu: true,
            sortable: false,
            resizable: false,
            filterable: false,
            renderCell(params) {
                return (
                    <Stack direction="row">
                        <IconButton customType="edit" onClick={(e) => { editHandler(e, params.row); }} />
                        <IconButton customType="delete" onClick={(e) => { deleteHandler(e, params.row); }} />
                        <RecordInfo
                            id={params.row.id}
                            eklemeTarihi={params.row.eklemeTarihi}
                            ekleyenKullanici={params.row.ekleyenKullanici}
                            guncellemeTarihi={params.row.guncellemeTarihi}
                            guncelleyenKullanici={params.row.guncelleyenKullanici}
                        />
                    </Stack>
                )
            },
        },

    ];

    const editHandler = (event: React.MouseEvent<HTMLButtonElement>, row: VwSonucIzlemeTanimDTO) => {
        dispatch(SonucIzlemeTanimSlice.actions.setEdit(true));
        dispatch(SonucIzlemeTanimSlice.actions.setActiveRow(row));
        dispatch(SonucIzlemeTanimSlice.actions.setOpen(true));

    }
    const deleteHandler = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, row: VwSonucIzlemeTanimDTO) => {
        confirm({
            title: translate(translatePath, "Kayıt Silme"),
            description: translate(translatePath, "Seçili kaydı silmek istediğinize emin misiniz?"),
            variant: 'danger'
        }).then(async () => {

            await sil({ id: row.id })
                .unwrap()
                .then((e) => {
                    dispatch(SonucIzlemeTanimSlice.actions.setData(state.data.filter((d) => d.id != row.id)));
                })
                .catch((e) => {
                    SnackbarUtils.error(translate(translatePath, e["message"]));
                });
        });
        dispatch(SonucIzlemeTanimSlice.actions.setOpen(false));
    };
    const addHandler = (event: React.MouseEvent<HTMLButtonElement>, params: GridRenderCellParams<GnlParametreDTO>) => {
        if (sonucIzlemeData.find(x => x.durumId == params.row.kodu && x.testGrupId == state.testGrubu?.key)) {
            SnackbarUtils.error(translate(translatePath, "Bu durum zaten eklenmiş. İsterseniz düzenleyebilirsiniz."));
            return;
        } else {
            dispatch(SonucIzlemeTanimSlice.actions.setDurumActiveRow(params.row));
            var activeRow = new VwSonucIzlemeTanimDTO();
            activeRow.aktif = params.row.aktif;
            activeRow.testGrupId = state.testGrubu?.key;
            activeRow.durumId = params.row.kodu;
            activeRow.bgRenk = "#ffffff";
            activeRow.txRenk = "#000000";

            dispatch(SonucIzlemeTanimSlice.actions.setActiveRow(activeRow));
            dispatch(SonucIzlemeTanimSlice.actions.setEdit(false));
            dispatch(SonucIzlemeTanimSlice.actions.setOpen(true));
        }



    }

    const handleChange = (_e: AutoCompleteTargetNumber, params: GnlParametreDTO, _reason: AutocompleteChangeReason
    ) => {
        dispatch(SonucIzlemeTanimSlice.actions.setTestGrubu(params));
    };

    return (

        <Grid container>
            <Grid item xl={12}>
                <Grid container>
                    <Grid item md={6}>
                        <Paper header={translate(translatePath, "İşlem Durumları")}>
                            <Grid container>
                                <Grid item xs={4}>
                                    <GnlParametreSelect
                                        required={true}
                                        filterCode={[1, 7]}
                                        parametreType={ParametreGrupEnum.TestGruplari}
                                        label={translate(translatePath, "Test Grubu")}
                                        name="testGrubu"
                                        value={state.testGrubu?.key}
                                        onChange={handleChange}
                                    />
                                </Grid>
                                <Grid item>
                                    <DataGrid
                                        enableQuickFilter
                                        pinnedColumns={{ right: ["action"] }}
                                        loading={durumlar.isFetching}
                                        sx={{ height: "80dvh" }}
                                        columns={durumColumns}
                                        rows={durumlar.data ? durumlar.data : []}
                                        sortModel={[{
                                            field: 'kodu',
                                            sort: 'asc',
                                        }]}
                                    />
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                    <Grid item md={6}>
                        <Paper header={translate(translatePath, "Sonuç İzleme Tanım Listesi")}>
                            <DataGrid
                                enableQuickFilter
                                pinnedColumns={{ right: ["action"] }}
                                loading={isSonucIzlemeFetching}
                                sx={{ height: "80dvh" }}
                                columns={sonucIzlemeTanimColumns}
                                rows={sonucIzlemeData ? sonucIzlemeData.filter(x => x.testGrupId == state.testGrubu?.key) : []}
                            />
                        </Paper>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>

    )
}
export default SonucIzlemeTanimListe